export default {
  user: {},
  loading: true,
  info: {
    banners: [],
    contact: {},
    about: {},
    countries: [],
    events: [],
    news: [],
    pageHeaders: [],
    posts: [],
    categories: [],
    institutions: [],
    members: 0,
    ready: false
  }
};



// WEBPACK FOOTER //
// ./src/redux/initialState.js